import { FunctionComponent, useState } from 'react'
import {
  Dropdown,
  Input,
  Text,
  getTheme,
  useMediaQuery,
} from '@conexasaude/conexa-hero'

import useStyles from '../DataEditingForm/styles'
import { RenderIf } from '@/components/RenderIf'
import { Icon } from '@conexasaude/iconography/icons'
import { Controller, useFormContext } from 'react-hook-form'
import { RELATIONSHIP_OPTIONS } from '@/modules/Attendance/constants'
import { UserConfirmDataFormType } from '../ConfirmContactWrapper/types'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'

const EmergencyContactSection: FunctionComponent = () => {
  const theme = getTheme()
  const { clinic } = useAuthContext()
  const isMobile = useMediaQuery(`(max-width: ${theme.grid.breakpoint.sm} )`)
  const [inputHidden, setInputHidden] = useState(false)
  const styles = useStyles()
  const { register, formState, control } =
    useFormContext<UserConfirmDataFormType>()

  const handleContactRequired = (label: string) => {
    return clinic?.flag?.HabilitarObrigatoriedadeContatoEmergencia
      ? `${label}*`
      : label
  }

  return (
    <div>
      <div css={styles.sectionTitle}>
        <Text color={theme.colors.brand.primary[500]} variant="headingSmall">
          Dados do contato de emergência
        </Text>
        <RenderIf condition={!isMobile}>
          <hr />
        </RenderIf>
        <RenderIf condition={isMobile}>
          <Icon
            onClick={() => setInputHidden(!inputHidden)}
            name={inputHidden ? 'arrow-down' : 'arrow-up'}
            size="medium"
            color={theme.colors.brand[300]}
          />
        </RenderIf>
      </div>
      <RenderIf condition={!inputHidden || !isMobile}>
        <div css={styles.sectionGridContent}>
          <div css={styles.sectionGridCol}>
            <Input
              {...register('emergencyContactFullName')}
              error={formState?.errors?.emergencyContactFullName?.message}
              label={handleContactRequired('Nome do seu contato de emergência')}
              maxLength={120}
              fullWidth
            />
          </div>
          <div css={styles.sectionGridCol}>
            <Controller
              name="relationship"
              control={control}
              render={({ field: { onChange, onBlur, value } }) => (
                <Dropdown
                  {...register('relationship')}
                  onChange={onChange}
                  onBlur={onBlur}
                  value={value}
                  error={formState?.errors?.relationship?.message}
                  label={handleContactRequired('Parentesco')}
                  placeholder="Selecione o grau de parentesco"
                  fullWidth
                  data={RELATIONSHIP_OPTIONS}
                />
              )}
            />
          </div>
          <div css={styles.sectionGridCol}>
            <Input
              {...register('emergencyContactCellphone')}
              error={formState?.errors?.emergencyContactCellphone?.message}
              label={handleContactRequired('Celular do contato de emergência')}
              placeholder={
                formState?.errors?.emergencyContactCellphone?.message
                  ? ''
                  : '(11) 99999-9999'
              }
              mask="(99) 99999-9999"
              fullWidth
            />
          </div>
        </div>
      </RenderIf>
    </div>
  )
}

export { EmergencyContactSection }
